// Pricing migration 32 (ADO-3985), T17 (AC7): what a screen reader hears for a multi-buy deal and
// the free units it earns, in one table, as row 18's spoken-text table (`pricing/
// priceExplanation.ts`, DEC-15) does for "was X, now Y". The visual parts these words stand for
// (the gift and arrow icons, the tick slots, the progress bar and the FREE chip) are decorative
// and hidden from assistive tech; the progress message itself is plain text in a polite live
// region, so it is not repeated here.

import type { MultibuyDeal } from '../api/multibuy-deals.client';
import { dealOfferText } from './multibuyDealText';

// WCAG 2.5.3 (Label in Name): each name starts with the words its control shows, so a voice
// command naming them reaches it. The Offer Strip note's "See the [deal] deal for [product]" does
// not contain them; that is the story's held designer question 22.

/** The compact strip's accessible name: the whole strip is the button, so its text first
 *  (`Buy 4, get 1 free · Ends 22 Nov +1 more`), then the product. */
export function compactStripName(stripText: string, productName: string): string {
  return `${stripText}, see the deal for ${productName}`;
}

/** The "See deal" button's accessible name: its label first, then the deal (its lowest tier, or
 *  the description of a deal with no free-unit tier) and the product. */
export function seeDealName(deal: MultibuyDeal, productName: string): string {
  return `See deal, ${dealOfferText(deal)}, for ${productName}`;
}

/** A line in a deal that is out of stock (R6 07u: "Screen readers hear the product name, then
 *  "unavailable""). */
export function spokenUnavailableLine(productName: string): string {
  return `${productName}, unavailable`;
}
